import { forwardRef, Ref, useState } from 'react';

import Input, { TInputProps } from '~/components/atoms/FormControls/Input';

import { ReactComponent as EyeIcon } from '~/assets/images/iconsLibrary/eye.svg';
import { ReactComponent as EyeCrossedIcon } from '~/assets/images/iconsLibrary/eye-crossed.svg';

function PasswordInputRenderer(
  props: Omit<TInputProps, 'icon' | 'onIconClick'>,
  ref: Ref<HTMLInputElement> | undefined,
): JSX.Element {
  const [isPasswordShown, setIsPasswordShown] = useState(false);
  return (
    <Input
      {...props}
      ref={ref}
      onIconClick={() => {
        setIsPasswordShown((prev) => !prev);
      }}
      icon={isPasswordShown ? <EyeIcon /> : <EyeCrossedIcon />}
      type={isPasswordShown ? 'text' : 'password'}
    />
  );
}

export const PasswordInput = forwardRef(PasswordInputRenderer);
